<template>
  <datatable
      :type="'companies'"
      :rowData="companies"
      :loadingMessage="loadingMessage"
      :noRowsMessage="noRowsMessage"
      :columns="columns"
      :paginationSize="50"
  />
</template>
<script>
import datatable from 'datatables/datatable';

export default {
  name: 'all_active_clients',
  components: {
    datatable
  },
  data() {
    return {
      companies: null,
      loadingMessage: 'Loading Active/Live Clients...',
      noRowsMessage: 'No Active/Live Clients Found',
      columns: []
    }
  },
  beforeMount() {
    this.$bus.$on('table::reload', ($event) => {
      if ($event.table === 'all_active_clients' && ($event.type === 'store' || $event.type === 'update')) {
        this.get_companies();
      }
    })

    // unified base columns
    this.columns = [
      {headerName: 'Name', field: 'company_name', minWidth: 200, pinned: 'left'},
      {headerName: 'Type', field: 'company_type', minWidth: 120, pinned: 'left'},
      {headerName: 'V3 Client', field: 'v3_client', minWidth: 80},
      {headerName: 'Lead Status', field: 'lead_status', minWidth: 120},
      {headerName: 'Pipeline Status', field: 'pipeline_status', minWidth: 160},
      {headerName: 'Pipeline Opportunity Size', field: 'pipeline_opportunity_size', minWidth: 160},
      {headerName: 'Weekly Deal Value', field: 'deal_value', minWidth: 140},
      {headerName: 'Consultant', field: 'primary_consultant_name', minWidth: 175},
      {headerName: 'City', field: 'city_town', minWidth: 160},
      {headerName: 'County', field: 'county', minWidth: 160},
      {headerName: 'Internal Ref', field: 'internal_finance_ref', minWidth: 140},
      {headerName: 'External Ref', field: 'external_finance_ref', minWidth: 140},
      // live-only extras
      {headerName: 'Fee (Admin)', minWidth: 120, valueGetter: this.fee_vg},
      {headerName: 'PE Taken', minWidth: 120, valueGetter: this.pe_taken_vg},
      {headerName: 'Resourcing', minWidth: 120, valueGetter: this.resourcing_vg},
    ];

    // payroll tweak: narrow & place V3 early
    if (this.crmType === 'payroll') {
      let [name, type, ...rest] = this.columns;
      this.columns = [name, type, {headerName: 'V3 Client', field: 'v3_client', minWidth: 40}, ...rest];
    }
  },
  mounted() {
    this.get_companies()
  },
  methods: {
    get_companies() {
      axios
          .get(`${this.crmApiPath}sunset/companies/live`)
          .then(response => this.companies = response.data)
          .catch(error => console.error(error?.response || error))
    },
    fee_vg(params) {
      if (params.data.fee_margin_type !== null) {
        if (params.data.fee_margin_type.indexOf('£') !== -1) {
          return this.$options.filters.currency(params.data.fee_margin_amount)
        } else if (params.data.fee_margin_type.indexOf('%') !== -1) {
          return this.$options.filters.percentage(params.data.fee_margin_amount)
        }
      }
      return ''
    },
    pe_taken_vg(params) {
      return params.data.payroll_pe_insurance ? 'Yes' : 'No'
    },
    resourcing_vg(params) {
      return params.data.service_resourcing ? 'Yes' : 'No'
    }
  },
  beforeDestroy() {
    this.companies = null
  }
}
</script>
